import React, { useState } from 'react';
import EnrollmentForm from './EnrollmentForm';
import './Hero.css';

const Hero: React.FC = () => {
  const [showEnrollmentForm, setShowEnrollmentForm] = useState(false);
  return (
    <section className="hero" id="home">
      {/* Decorative Background Elements */}
      <div className="hero-bg-decoration">
        <div className="bg-circle circle-1"></div>
        <div className="bg-circle circle-2"></div>
        <div className="bg-circle circle-3"></div>
      </div>

      <div className="container">
        <div className="hero-content">
          

          {/* Decorative Elements */}
          <div className="decorative-elements">
            <div className="deco-item sun">☀️</div>
            <div className="deco-item cloud cloud-1">☁️</div>
            <div className="deco-item cloud cloud-2">☁️</div>
            <div className="deco-item star star-1">⭐</div>
            <div className="deco-item star star-2">✨</div>
            <div className="deco-item balloon">🎈</div>
          </div>

          <div className="hero-image">
            <div className="image-wrapper">
              {/* Main Image Circle */}
              <div className="hero-main-circle">
                <div className="children-illustration">
                  <div className="child-group">
                    {/* <span className="child">👧</span>
                    <span className="child">👦</span>
                    <span className="child">👶</span> */}
                    <img src="images/hero/hero_img.jpeg" alt="hero-img" />
                  </div>
                </div>
              </div>

              {/* Floating Elements */}
              <div className="floating-elements">
                <div className="float-item item-1">
                  <div className="float-card">
                    <span className="float-icon">📚</span>
                    <span className="float-text">Learning</span>
                  </div>
                </div>
                <div className="float-item item-2">
                  <div className="float-card">
                    <span className="float-icon">🎨</span>
                    <span className="float-text">Creative</span>
                  </div>
                </div>
                <div className="float-item item-3">
                  <div className="float-card">
                    <span className="float-icon">⚽</span>
                    <span className="float-text">Active</span>
                  </div>
                </div>
                <div className="float-item item-4">
                  <div className="float-card">
                    <span className="float-icon">🎵</span>
                    <span className="float-text">Musical</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-text">
            <div className="welcome-badge">
              <h2 className="badge-text-school-name">
                Welcome to<span className="badge-icon">📚</span> <span className="badge-text-highlight ">New ABC Montessori School</span>
              </h2>
            </div>
            <h1>
              Where Little <span className="highlight">Minds</span> <span> Grow </span>
              <span className="gradient-text"> Big Dreams</span>
            </h1>
            <p>
              A nurturing environment where children discover, explore, and develop
              through play-based learning and creative activities designed just for them.
            </p>
            <div className="hero-buttons">
              <button className="cta-button primary"
              onClick={() => setShowEnrollmentForm(true)}>
                <span>Enroll Now</span>
                <i className="fas fa-arrow-right"></i>
              </button>
              {/* <button className="cta-button secondary">
                <i className="fas fa-play-circle"></i>
                <span>Watch Video</span>
              </button> */}
            </div>
            
            {/* Stats */}
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-icon">👶</div>
                <div className="stat-info">
                  <h3>15000+</h3>
                  <p>Happy Students</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">🏆</div>
                <div className="stat-info">
                  <h3>17+</h3>
                  <p>Years Experience</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">⭐</div>
                <div className="stat-info">
                  <h3>98%</h3>
                  <p>Satisfaction Rate</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showEnrollmentForm && (
        <EnrollmentForm onClose={() => setShowEnrollmentForm(false)} />
      )}
    </section>
  );
};

export default Hero;
